import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) {
            window.scrollTo(0, 0); // Прокрутка вверх при смене маршрута
        }
    }, [hash, pathname]);

    return null;
}
